<template>
    <div>
        <div class="flex flex-col min-h-0 h-full p-6 pt-5 | 2xl:p-8 2xl:pt-8">
            <page-header :title="$t('configs.pageTitle')" />

            <main class="flex flex-col min-h-0 h-full rounded shadow-lg bg-white">
                <div class="flex items-stretch h-full">
                    <div class="flex-1 flex flex-col justify-between max-w-xs h-full border-r border-gray-200 rounded-l text-base bg-gray-50 overflow-auto">
                        <div>
                            <nav class="flex flex-col items-start w-full p-8">
                                <configs-nav-header class="mb-2">
                                    {{ authUser.account.name }}
                                </configs-nav-header>

                                <configs-nav-item :to="{ name: 'configs.team.details' }" v-if="hasAccessToTeamSettings">
                                    {{ $t('configs.leftPanel.teamDetails') }}
                                </configs-nav-item>
                                <configs-nav-item :to="{ name: 'configs.team.users' }" v-if="hasAccessToTeamSettings">
                                    {{ $t('configs.leftPanel.users') }}
                                </configs-nav-item>
                                <configs-nav-item :to="{ name: 'configs.team.templates' }">
                                    {{ $t('configs.leftPanel.templates') }}
                                </configs-nav-item>
                            </nav>

                            <nav class="flex flex-col items-start p-8">
                                <configs-nav-header class="mb-2">
                                    {{ formatFullName(authUser) }}
                                </configs-nav-header>

                                <configs-nav-item :to="{ name: 'configs.user.profile' }">
                                    {{ $t('configs.leftPanel.profile') }}
                                </configs-nav-item>
                                <configs-nav-item :to="{ name: 'configs.user.notifications' }">
                                    {{ $t('configs.leftPanel.notifications') }}
                                </configs-nav-item>
                                <configs-nav-item :to="{ name: 'configs.user.messages' }">
                                    {{ $t('configs.leftPanel.messages') }}
                                </configs-nav-item>
                            </nav>
                        </div>

                        <segments-usage-progress class="p-8 text-center" v-if="authUser.account.monthly_segments_limit" />
                    </div>

                    <div class="flex-2 h-full">
                        <router-view class="flex flex-col h-full" />
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import assign from 'lodash/assign.js';
    import { mapState, mapGetters } from 'vuex';
    import ConfigsNavHeader from '@/components/ConfigsNavHeader.vue';
    import ConfigsNavItem from '@/components/ConfigsNavItem.vue';
    import PageHeader from '@/components/PageHeader.vue';
    import SegmentsUsageProgress from '@/components/SegmentsUsageProgress.vue';

    export default {
        components: {
            ConfigsNavHeader,
            ConfigsNavItem,
            PageHeader,
            SegmentsUsageProgress,
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapGetters([
                'hasAccessToTeamSettings',
            ]),
        },

        methods: {
            saveConfigs() {
                this.saving = true;

                this.user.options.crm_confirmation_message = this.duplicateTranslationIfEmpty(this.user.options.crm_confirmation_message);

                this.updateUser(this.user)
                    .then(user => {
                        this.saving = false;

                        // Update authUser
                        const newAuthUser = assign(cloneDeep(this.authUser), user);
                        this.setAuthUser(newAuthUser);

                        this.$notify.show({
                            type: 'success',
                            message: this.$t('configs.rightPanel.messages.messages.updateSuccessful'),
                        });
                    })
                    .catch(() => {
                        this.saving = false;

                        this.$notify.show({
                            type: 'error',
                            message: this.$t('configs.rightPanel.messages.errors.update'),
                        });
                    });
            },
        },
    };
</script>
